module.exports = __webpack_public_path__ + "img/img-planner.4f14a115.png";